module.exports = __webpack_public_path__ + "static/assets/83d5e00640a1fe897961c70e35473c86.svg";